module.exports = __webpack_public_path__ + "static/media/3.c53983f1.jpg";